import React, { useEffect } from "react";
import Footer from "./servesies/footer/Footer";
import FooterBottom from "./servesies/footer/FooterBottom";
import ScrollToTopButton from "./common/UI/ScrollToTopButton/ScrollToTopButton";
import Navbar from "./servesies/navbar/Navbar";
import Router from "./router/Router";
import { useLocation } from "react-router-dom";

function App() {
  useEffect(() => {
    if(!window.localStorage.getItem("i18nextLng")){
      window.localStorage.setItem("i18nextLng" , "ar")
    }
  },[])
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
      <Navbar />
      <div className="max-w-screen-xl mx-auto">
        <Router />
      </div>
      {/* <Footer />
      <FooterBottom /> */}
      <ScrollToTopButton />
    </div>
  );
}

export default App;
